import React from 'react';
import { ReactComponent as FigMessageChatCircleComponent } from './FigMessageChatCircle.svg';

const FigMessageChatCircle = (props) => (
  <FigMessageChatCircleComponent {...props} />
);

export default FigMessageChatCircle;
